<div class="card flex switch-cntr">
    <p-inputSwitch
        (onChange)="toggle()"></p-inputSwitch>
    {{ configuration.label }}
</div>
